export const filterOption = (
  input: string,
  option?: { label: string; value: string },
) => {
  return (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
};
